import _ from 'lodash';
import reserveCheck from './reserveCheck';
import roomManagement from './roomManagement';
import userManagement from './userManagement';
export default _.union(
  reserveCheck,
  roomManagement,
  userManagement,
  [{
    name: 'receptionSupervise',
    path: '/receptionSupervise',
    meta: { title: '招接待管理系统' },
    component: require('views/common/blank.vue').default
  }]
);
